/* MOTURO product gallery · 1.0.0 (2026-10-05 ux-gallery)
   Thumbnails, main image and one native <dialog> lightbox per gallery, synchronised by the real image identity
   (data-image-id; JSON block data-gallery-data rendered by sections/moturo-product.liquid with id, alt, size and the
   real Shopify CDN candidates per image, high-res up to 2400 px and never upscaled). No library, no synthetic images.
   Page: thumbnail click, Enter, Space or arrow keys switch the main image (src, srcset, sizes, width/height, alt and
   the high-res link are rebuilt from the data – no stale candidates); the main image link opens the dialog, without
   JS it is a plain link to the real high-res file. Dialog: previous/next, counter, close, Escape, arrow keys,
   Home/End, focus containment and return, scroll lock with restored position, backdrop click, click/tap zoom 1x/2x
   bounded by the source size with scroll and drag panning, touch swipe while not zoomed (pinch zoom stays native via
   touch-action pan-y pinch-zoom), recoverable load errors with retry. Every listener is scoped to its gallery; the
   document keydown handler exists only while that dialog is open. shopify:section:load rebinds, shopify:section:unload
   closes. moturo-store.js hands the variant image over through the DOM event moturo:gallery:show {id, src}. */
(function () {
  'use strict';
  const I18N = (() => { try { const el = typeof document !== 'undefined' && document.getElementById('MoturoI18n'); const d = el ? JSON.parse(el.textContent) : null; return d && typeof d === 'object' ? d : {}; } catch (_) { return {}; } })();
  const L = (name, base, vars) => { let s = typeof I18N[name] === 'string' ? I18N[name] : base; if (vars) for (const n of Object.keys(vars)) s = s.split('{{ ' + n + ' }}').join(String(vars[n])); return s; };
  const q = (selector, root) => Array.prototype.slice.call((root || document).querySelectorAll(selector));
  const MAIN_SIZES = '(max-width: 820px) 100vw, 50vw';
  const base = url => String(url || '').split('?')[0];
  const withRetry = (url, n) => n ? url + (url.includes('?') ? '&' : '?') + 'retry=' + n : url;

  function readData(gallery) {
    const el = gallery.querySelector('script[data-gallery-data]');
    if (!el) return [];
    try {
      const list = JSON.parse(el.textContent);
      return Array.isArray(list) ? list.filter(d => d && d.full && Array.isArray(d.srcset) && d.srcset.length).map(d => ({
        id: String(d.id), alt: typeof d.alt === 'string' ? d.alt : '', width: Number(d.width) || 0, height: Number(d.height) || 0, full: String(d.full),
        srcset: d.srcset.filter(c => Array.isArray(c) && c.length === 2 && Number(c[0]) > 0).map(c => [Number(c[0]), String(c[1])]).sort((a, b) => a[0] - b[0])
      })) : [];
    } catch (_) { return []; }
  }

  function bindGallery(gallery) {
    const data = readData(gallery);
    const main = gallery.querySelector('[data-gallery-main]');
    const link = gallery.querySelector('[data-gallery-open]');
    const thumbs = q('[data-gallery-thumb]', gallery);
    const mainError = gallery.querySelector('[data-gallery-main-error]');
    const dialog = gallery.querySelector('[data-gallery-dialog]');
    if (!main || !data.length) return null;
    const indexOf = (id, src) => {
      let i = id ? data.findIndex(d => d.id === String(id)) : -1;
      if (i < 0 && src) { const b = base(src); i = data.findIndex(d => base(d.full) === b || d.srcset.some(c => base(c[1]) === b)); }
      return i;
    };
    const state = { index: Math.max(0, indexOf(main.dataset.imageId, main.currentSrc || main.src)), open: false, zoom: 1, opener: null, scrollY: 0, bodyStyle: null, retries: 0, swiped: false };
    const total = data.length;

    /* ---- page: main image and thumbnails ---- */
    function showMain(i, retry) {
      const d = data[i];
      if (!d) return;
      state.index = i;
      let list = d.srcset.filter(c => c[0] <= 1200);
      if (!list.length) list = [d.srcset[0]];
      const n = retry || 0;
      main.srcset = list.map(c => withRetry(c[1], n) + ' ' + c[0] + 'w').join(', ');
      main.sizes = MAIN_SIZES;
      const top = list[list.length - 1];
      main.width = top[0];
      main.height = d.width > 0 ? Math.max(1, Math.round(top[0] * d.height / d.width)) : top[0];
      main.alt = d.alt;
      main.dataset.imageId = d.id;
      main.src = withRetry(top[1], n);
      if (link) link.href = withRetry(d.full, n);
      thumbs.forEach(t => t.setAttribute('aria-current', String(t.dataset.imageId === d.id)));
      if (mainError) mainError.hidden = true;
    }
    main.addEventListener('error', () => { if (mainError) mainError.hidden = false; });
    main.addEventListener('load', () => { if (mainError) mainError.hidden = true; });
    if (mainError) { const retry = mainError.querySelector('[data-gallery-main-retry]'); if (retry) retry.addEventListener('click', () => { state.retries += 1; showMain(state.index, state.retries); }); }
    thumbs.forEach((thumb, i) => {
      const idx = indexOf(thumb.dataset.imageId, thumb.href);
      thumb.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (idx >= 0) showMain(idx);
      });
      thumb.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); if (idx >= 0) showMain(idx); return; }
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const next = thumbs[(i + (event.key === 'ArrowRight' ? 1 : thumbs.length - 1)) % thumbs.length];
        next.focus();
        const nextIdx = indexOf(next.dataset.imageId, next.href);
        if (nextIdx >= 0) showMain(nextIdx);
      });
    });
    gallery.addEventListener('moturo:gallery:show', event => {
      const detail = (event && event.detail) || {};
      const i = indexOf(detail.id, detail.src);
      if (i < 0) return;
      showMain(i);
      if (state.open) showFull(i);
    });

    /* ---- dialog ---- */
    if (!dialog || !link) return { destroy() {} };
    const full = dialog.querySelector('[data-gallery-full]');
    const viewport = dialog.querySelector('[data-gallery-viewport]');
    const counter = dialog.querySelector('[data-gallery-counter]');
    const prev = dialog.querySelector('[data-gallery-prev]');
    const next = dialog.querySelector('[data-gallery-next]');
    const close = dialog.querySelector('[data-gallery-close]');
    const zoomButton = dialog.querySelector('[data-gallery-zoom]');
    const zoomLabel = dialog.querySelector('[data-gallery-zoom-label]');
    const error = dialog.querySelector('[data-gallery-error]');
    const retryButton = dialog.querySelector('[data-gallery-retry]');
    const stage = viewport ? viewport.parentElement : null, head = dialog.querySelector('.gallery-head');
    if (!full || !viewport) return { destroy() {} };
    const nativeModal = typeof dialog.showModal === 'function';

    function setZoomUi(zoomed, zoomable) {
      viewport.dataset.zoom = zoomed ? '2' : '1';
      viewport.dataset.zoomable = String(!!zoomable);
      if (zoomButton) {
        zoomButton.setAttribute('aria-pressed', String(zoomed));
        zoomButton.disabled = !zoomable;
        if (zoomLabel) zoomLabel.textContent = zoomed ? (zoomButton.dataset.labelOut || L('gallery_zoom_out', 'Verkleinern')) : (zoomButton.dataset.labelIn || L('gallery_zoom_in', 'Vergrößern'));
      }
    }
    function zoomFactor() {
      if (!full.naturalWidth || !full.clientWidth) return 1;
      return Math.min(2, full.naturalWidth / full.clientWidth);
    }
    function setZoom(zoomIn, fx, fy) {
      if (!zoomIn || state.zoom > 1) {
        full.style.width = ''; full.style.height = '';
        state.zoom = 1;
        viewport.scrollTo(0, 0);
        setZoomUi(false, zoomFactor() >= 1.15);
        return;
      }
      const factor = zoomFactor();
      if (factor < 1.15) { setZoomUi(false, false); return; }
      const w = Math.round(full.clientWidth * factor), h = Math.round(full.clientHeight * factor);
      state.zoom = factor;
      setZoomUi(true, true);
      full.style.width = w + 'px'; full.style.height = h + 'px';
      const px = typeof fx === 'number' ? fx : 0.5, py = typeof fy === 'number' ? fy : 0.5;
      viewport.scrollLeft = Math.max(0, w * px - viewport.clientWidth / 2);
      viewport.scrollTop = Math.max(0, h * py - viewport.clientHeight / 2);
    }
    function showFull(i, retry) {
      const d = data[i];
      if (!d) return;
      state.index = i;
      const n = retry || 0;
      if (state.zoom > 1) setZoom(false);
      if (error) error.hidden = true;
      full.width = d.width || 2400;
      full.height = d.height || d.width || 2400;
      full.alt = d.alt;
      full.dataset.imageId = d.id;
      // Load the full source only in the dialog: width-descriptor srcset density-corrects
      // naturalWidth to the viewport and would incorrectly disable mobile zoom.
      full.removeAttribute('srcset');
      full.removeAttribute('sizes');
      full.src = withRetry(d.full, n);
      if (counter) { counter.textContent = L('gallery_counter', 'Bild {{ index }} von {{ total }}', { index: i + 1, total }); counter.hidden = total < 2; }
      if (prev) prev.hidden = total < 2;
      if (next) next.hidden = total < 2;
      setZoomUi(false, false);
      showMain(i);
      if (total > 1) { try { new Image().src = data[(i + 1) % total].full; new Image().src = data[(i + total - 1) % total].full; } catch (_) {} }
    }
    full.addEventListener('load', () => { if (error) error.hidden = true; setZoomUi(false, zoomFactor() >= 1.15); });
    full.addEventListener('error', () => { if (!state.open) return; if (error) error.hidden = false; setZoomUi(false, false); });
    if (retryButton) retryButton.addEventListener('click', () => { state.retries += 1; showFull(state.index, state.retries); });
    const step = delta => { if (total < 2) return; showFull((state.index + delta + total) % total); };

    function lockScroll() {
      const body = document.body, html = document.documentElement;
      state.scrollY = window.scrollY || html.scrollTop || 0;
      const gap = window.innerWidth - html.clientWidth;
      state.bodyStyle = { position: body.style.position, top: body.style.top, left: body.style.left, right: body.style.right, width: body.style.width, overflow: body.style.overflow, paddingRight: body.style.paddingRight };
      body.style.position = 'fixed'; body.style.top = -state.scrollY + 'px'; body.style.left = '0'; body.style.right = '0'; body.style.width = '100%'; body.style.overflow = 'hidden';
      if (gap > 0) body.style.paddingRight = gap + 'px';
      html.dataset.galleryOpen = 'true';
    }
    function unlockScroll() {
      if (!state.bodyStyle) return;
      const body = document.body, html = document.documentElement, saved = state.bodyStyle;
      state.bodyStyle = null;
      body.style.position = saved.position; body.style.top = saved.top; body.style.left = saved.left; body.style.right = saved.right; body.style.width = saved.width; body.style.overflow = saved.overflow; body.style.paddingRight = saved.paddingRight;
      delete html.dataset.galleryOpen;
      window.scrollTo(0, state.scrollY);
    }
    const focusables = () => q('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', dialog).filter(e => !e.hidden && !e.disabled && !e.closest('[hidden]') && e.getClientRects().length);
    function onKey(event) {
      if (!state.open) return;
      if (event.key === 'Tab') {
        const items = focusables();
        if (!items.length) { event.preventDefault(); return; }
        const first = items[0], last = items[items.length - 1], active = document.activeElement;
        if (event.shiftKey && (active === first || !dialog.contains(active))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (active === last || !dialog.contains(active))) { event.preventDefault(); first.focus(); }
        return;
      }
      if (event.key === 'Escape' && !nativeModal) { event.preventDefault(); closeDialog(); return; }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        if (state.zoom > 1) { viewport.scrollLeft += event.key === 'ArrowRight' ? 80 : -80; return; }
        step(event.key === 'ArrowRight' ? 1 : -1);
        return;
      }
      if ((event.key === 'ArrowUp' || event.key === 'ArrowDown') && state.zoom > 1) { event.preventDefault(); viewport.scrollTop += event.key === 'ArrowDown' ? 80 : -80; return; }
      if (event.key === 'Home' && total > 1 && state.zoom === 1) { event.preventDefault(); showFull(0); return; }
      if (event.key === 'End' && total > 1 && state.zoom === 1) { event.preventDefault(); showFull(total - 1); }
    }
    function openDialog(i) {
      if (state.open) return;
      state.opener = document.activeElement && document.activeElement !== document.body ? document.activeElement : link;
      lockScroll();
      state.open = true;
      showFull(i >= 0 ? i : state.index);
      try { if (nativeModal) dialog.showModal(); else { dialog.setAttribute('open', ''); dialog.setAttribute('role', 'dialog'); dialog.setAttribute('aria-modal', 'true'); } } catch (_) { dialog.setAttribute('open', ''); }
      document.addEventListener('keydown', onKey, true);
      if (close) close.focus(); else { const items = focusables(); if (items.length) items[0].focus(); }
    }
    function closeDialog() {
      if (!state.open) return;
      state.open = false;
      document.removeEventListener('keydown', onKey, true);
      if (state.zoom > 1) setZoom(false);
      try { if (nativeModal && dialog.open) dialog.close(); } catch (_) {}
      dialog.removeAttribute('open');
      unlockScroll();
      const back = state.opener;
      state.opener = null;
      if (back && back.isConnected && typeof back.focus === 'function') { try { back.focus(); } catch (_) {} }
    }
    link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      openDialog(state.index);
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(); });
    dialog.addEventListener('close', () => { if (state.open) closeDialog(); });
    /* Backdrop: the dialog box itself and the ink areas around the image (head row, stage, viewport) close; controls,
       the image and the error line do not. A click that ends a swipe or a drag is ignored. */
    dialog.addEventListener('click', event => {
      if (state.swiped) { state.swiped = false; return; }
      const t = event.target;
      if (t === dialog || t === head || t === stage || t === viewport) closeDialog();
    });
    if (close) close.addEventListener('click', () => closeDialog());
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    if (zoomButton) zoomButton.addEventListener('click', () => setZoom(state.zoom === 1));

    /* Pointer handling on the viewport: click/tap toggles the zoom (centred on the point), mouse drag pans while
       zoomed, a horizontal touch/pen swipe while not zoomed switches the image. Vertical pans and pinch zoom stay native. */
    let pointer = null;
    viewport.addEventListener('pointerdown', event => {
      if (event.button !== 0) return;
      pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, type: event.pointerType, moved: false, scrollLeft: viewport.scrollLeft, scrollTop: viewport.scrollTop };
      if (state.zoom > 1 && event.pointerType === 'mouse') { viewport.dataset.panning = 'true'; try { viewport.setPointerCapture(event.pointerId); } catch (_) {} }
    });
    viewport.addEventListener('pointermove', event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) pointer.moved = true;
      if (state.zoom > 1 && pointer.type === 'mouse') { viewport.scrollLeft = pointer.scrollLeft - dx; viewport.scrollTop = pointer.scrollTop - dy; }
    });
    const endPointer = event => {
      if (!pointer || event.pointerId !== pointer.id) return;
      const p = pointer; pointer = null;
      delete viewport.dataset.panning;
      try { viewport.releasePointerCapture(event.pointerId); } catch (_) {}
      if (event.type === 'pointercancel') return;
      const dx = event.clientX - p.x, dy = event.clientY - p.y;
      if (state.zoom === 1 && p.type !== 'mouse' && Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.2) { state.swiped = true; setTimeout(() => { state.swiped = false; }, 400); step(dx < 0 ? 1 : -1); return; }
      if (p.moved) { state.swiped = true; setTimeout(() => { state.swiped = false; }, 400); }
    };
    viewport.addEventListener('pointerup', endPointer);
    viewport.addEventListener('pointercancel', endPointer);
    full.addEventListener('click', event => {
      if (state.swiped) return;
      const r = full.getBoundingClientRect();
      const fx = r.width ? (event.clientX - r.left) / r.width : 0.5, fy = r.height ? (event.clientY - r.top) / r.height : 0.5;
      setZoom(state.zoom === 1, fx, fy);
    });
    showMain(state.index);
    return { destroy() { closeDialog(); } };
  }

  function bindAll(root) {
    q('[data-gallery]', root && root.querySelectorAll ? root : document).forEach(gallery => {
      if (gallery.dataset.galleryBound) return;
      gallery.dataset.galleryBound = 'true';
      gallery.__moturoGallery = bindGallery(gallery);
    });
  }
  document.addEventListener('shopify:section:load', event => bindAll(event.target));
  document.addEventListener('shopify:section:unload', event => { q('[data-gallery]', event.target && event.target.querySelectorAll ? event.target : document).forEach(g => { if (g.__moturoGallery) g.__moturoGallery.destroy(); }); });
  window.MoturoGallery = { version: '1.0.0', bind: bindAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindAll(document)); else bindAll(document);
})();
